import { createCustomTheme, APP_COLORS } from '@advito/common';

import { roboto, robotoBold, robotoMedium } from './fonts';

const theme = createCustomTheme([roboto, robotoBold, robotoMedium], APP_COLORS.A360);

export default theme;
